import { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { ManualSkillsDialog } from './manual-skills-dialog';
import EmptyStateManuallyAdded from '@/assets/images/svg/empty-state-manually-added.svg';
import { ContentBox } from '@/components/shared/content-box';
import { StateMessage } from '@/components/shared/state-message';
import { Skeleton } from '@/packages/skill-management/components/skeleton';
import { SkillsList } from '@/packages/skill-management/components/skills-list';
import { useSkills } from '@/packages/skill-management/context/skills';

const EmptyState = ({ onClick }: { onClick: () => void }) => (
  <StateMessage
    title="Adição de habilidades"
    description="Adicione habilidades específicas de forma manual."
    image={EmptyStateManuallyAdded}
    imageSize={{ width: 64, height: 64 }}
    action={{
      onClick: () => onClick(),
      label: 'Adicionar habilidades',
    }}
  />
);

export const Manual = () => {
  const { manuallyAddedSkills, isLoadingSelectedSkills } = useSkills();
  const [manualSkillsDialogOpen, setManualSkillsDialogOpen] = useState(false);

  const hasManuallyAddedSkills =
    manuallyAddedSkills && manuallyAddedSkills.length > 0;

  if (isLoadingSelectedSkills) return <Skeleton />;

  return (
    <>
      {!hasManuallyAddedSkills && (
        <EmptyState onClick={() => setManualSkillsDialogOpen(true)} />
      )}
      {hasManuallyAddedSkills && (
        <ContentBox spacing={2} alignItems="start">
          <Typography variant="h3">Habilidades em foco</Typography>
          <SkillsList
            checkedSkills={manuallyAddedSkills}
            uncheckedSkills={[]}
            onClick={() => setManualSkillsDialogOpen(true)}
          />
          <Button onClick={() => setManualSkillsDialogOpen(true)}>
            Editar habilidades
          </Button>
        </ContentBox>
      )}
      {manualSkillsDialogOpen && (
        <ManualSkillsDialog onClose={() => setManualSkillsDialogOpen(false)} />
      )}
    </>
  );
};
